import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicLayoutEffect } from '../hooks/use-isomorphic-layout-effect';
import { createAtlaskitPortal, createPortalParent } from '../utils/portal-dom-utils';
export default function InternalPortalNew(props) {
  const {
    zIndex,
    children
  } = props;
  const [atlaskitPortal, setAtlaskitPortal] = useState(null);
  useIsomorphicLayoutEffect(() => {
    const tempPortalContainer = createAtlaskitPortal(zIndex);
    setAtlaskitPortal(tempPortalContainer);
    const portalParent = createPortalParent();
    if (!tempPortalContainer || !portalParent) {
      return;
    }
    portalParent.appendChild(tempPortalContainer);
    return () => {
      if (tempPortalContainer) {
        portalParent.removeChild(tempPortalContainer);
      }
      setAtlaskitPortal(null);
    };
  }, [zIndex]);
  return atlaskitPortal ? /*#__PURE__*/createPortal(children, atlaskitPortal) : null;
}